import axios from 'axios';
import { store } from '../store/store';
import { navigateTo } from '../utils/navigationHelper'; 

const axiosInstance = axios.create({
    baseURL: 'https://webideainfotech.in/hotelbillbe/public/api', 
   // baseURL: 'http://127.0.0.1:8000/api'    
});

axiosInstance.interceptors.request.use((config) => {
    const state = store.getState();
    const token = state.auth.auth.idToken;
    let tokenDetailsString = localStorage.getItem('userDetails');
    config.params = config.params || {};
    if (tokenDetailsString) {
        tokenDetailsString = JSON.parse(tokenDetailsString);
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${tokenDetailsString.token}`;
    }
     
    return config;
});

axiosInstance.interceptors.response.use(
    (response) =>{        
        if(response.data && response.data.error && response.data.error === "Unauthorized")
        {           
            localStorage.removeItem("userDetails"); 
            navigateTo("/hotelbill");

        }else{
            return response.data;
        }       

    } , 
    (error) => {
        if (error.response) {
           
            console.log(error.response);
            switch (error.response.status) {
               
                case 401:                  
                    localStorage.removeItem("userDetails"); 
                    navigateTo("/hotelbill");

                    break;
              
                default:
                    console.log(error.response.data.message );
            }
        } else if (error.request) {
            
            console.log("No response from server. Check your internet connection.");
        } else {
           
            console.log("An unexpected error occurred.");
        }
        return Promise.reject(error); 
    }
);
export default axiosInstance;
